module.exports = __webpack_public_path__ + "resources/images/moneyou-4636ff195c014d49f63d82677c3814ba-cache.png";